import { extractFirstRiskMatrixId } from '../../../utils/risk-rating-utils';
import type { RendererProps } from './renderer-registry';
import RiskRatingDisplay from './risk-rating-display';

const RiskRatingRenderer = ({ records, columnEntityReference }: RendererProps) => {
  if (!records.length || !columnEntityReference.linkedFieldId) return null;

  const riskMatrixId = extractFirstRiskMatrixId(records, columnEntityReference.linkedFieldId);

  return (
    <RiskRatingDisplay
      records={records}
      linkedFieldId={columnEntityReference.linkedFieldId}
      riskMatrixId={riskMatrixId}
      displayRecordListColour={columnEntityReference.displayRecordListColour}
    />
  );
};

export default RiskRatingRenderer;
